import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@app/shared/components/icon/icon';

@Component({
  selector: 'app-skeleton',
  imports: [CommonModule, IconComponent],
  standalone: true,
  templateUrl: './skeleton.html',
  styleUrl: './skeleton.scss',
})
export class SkeletonComponent {
  @Input() type: 'table' | 'alert' | 'card' = 'table';
  @Input() messages: string[] = [''];

  tableRows = Array.from({ length: 11 });
  tableCols = Array.from({ length: 7 });
}
